import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { getContent } from '../../util/responseUtil';
import API_TICKET_LIST from '../../api/apiTicketList';

import IconCheckmarkCircle from '../../assets/icons/IconCheckmarkCircle';
import IconUncheckCircle from '../../assets/icons/IconUncheckCircle';
import API_SOLUTION from '../../api/apiSolution';
import { CheckPermissionApi } from '../../util/permission';
import {
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE,
    TICKET_LIST_MEMBER_VIEW,
    TICKET_LIST_NEW_CSO_VIEW,
    TICKET_LIST_NEW_MANAGER_VIEW,
    TICKET_LIST_SOLUTION_VIEW
} from '../../constants/menuPermissionConstant';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';

class TicketSort extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderBy: [],
            selected: '',
            isOpened: false
        }
    }

    handleSelect = data => {
        this.setState({
            selected: data,
            isOpened: false
        })
        this.props.handleChangeOrderBy(data)
    }

    initiateSortTicket = async () => {
        await this.getDataTicketInitiate();

        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            this.setState({
                orderBy: this.state.orderBy.filter(item => item !== "remark.value::integer")
            })
        }
    }

    getDataTicketInitiate = () => {
        if (CheckPermissionApi(TICKET_LIST_ALL_VIEW_ASSIGNEE, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiate(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            orderBy: getContent(res).valid_order_by
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_ALL_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateLead(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            orderBy: getContent(res).valid_order_by
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_NEW_CSO_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateUnassigned(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            orderBy: getContent(res).valid_order_by
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_NEW_MANAGER_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateAssignedUnassigned(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            orderBy: getContent(res).valid_order_by
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_MEMBER_VIEW, this.props.userDetail.permissions)) {
            return API_TICKET_LIST.getDataTicketInitiateMember(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            orderBy: getContent(res).valid_order_by
                        })
                    }
                })
        }
        if (CheckPermissionApi(TICKET_LIST_SOLUTION_VIEW, this.props.userDetail.permissions)) {
            return API_SOLUTION.getDataTicketInitiateSolution(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            orderBy: getContent(res).valid_order_by
                        })
                    }
                })
        }
    }

    handleDropdown = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target)) {
            this.setState({
                isOpened: false
            })
        }
    }

    sortLabel = selected => {
        if (selected === 'created_at') return 'Tanggal Pembuatan'
        if (selected === 'updated_at') return 'Perubahan Terakhir'
        if (selected === 'priority_level') return 'Prioritas'
        if (selected === 'status') return 'Status'
        if (selected === 'remark.value::integer') return 'Status'
    }

    componentDidMount() {
        this._isMounted = true;
        this.dropdownRef = createRef();

        this.initiateSortTicket();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpened !== this.state.isOpened) {
            if (this.state.isOpened) {
                document.addEventListener('click', this.handleDropdown)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('click', this.handleDropdown);
    }

    render() {
        return (
            <div className="ticket-sort flex items-center relative">
                <input type="checkbox" id="ckbisordered" checked={this.props.isOrdered} onChange={this.props.handleIsOrdered} />
                <div className="ml-2 cursor-pointer select-none mr-10" id="btnsort" onClick={() => this.setState({ isOpened: !this.state.isOpened })} ref={this.dropdownRef}>
                    <span>Disortir : </span>
                    <span className="text-darkblue font-bold">
                        {this.state.selected === '' ? 'Tanggal Pembuatan' : this.sortLabel(this.state.selected)}
                        <FontAwesomeIcon icon={faChevronDown} className="ml-2" />
                    </span>
                </div>
                <div className={this.state.isOpened ? "dropdown-list text-sm w-60 mt-3" : "hidden"}>
                    {
                        this.state.orderBy !== undefined && this.state.orderBy.map((data, idx) =>
                            idx !== 0 && <div className="dropdown-list__item" key={idx} id="btnsortselect" onClick={() => this.handleSelect(data)}>
                                {
                                    this.state.selected === data ?
                                        <div className="pt-3 pl-3 pr-3 bg-blue-200">
                                            <div className={this.state.orderBy.length === idx + 1 ? "pb-3 flex justify-between items-center capitalize" : "pb-3 flex justify-between items-center border-b-2 border-gray capitalize"}>
                                                <div className="select-none">
                                                    {this.sortLabel(data)}
                                                </div>
                                                <IconCheckmarkCircle />
                                            </div>
                                        </div>
                                        :
                                        <div className="pt-3 pl-3 pr-3 hover:bg-blue-100">
                                            <div className={this.state.orderBy.length === idx + 1 ? "pb-3 flex justify-between items-center capitalize" : "pb-3 flex justify-between items-center border-b-2 border-gray capitalize"}>
                                                <div className="select-none">
                                                    {this.sortLabel(data)}
                                                </div>
                                                <IconUncheckCircle />
                                            </div>
                                        </div>
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(TicketSort);